import {
  FileRepository
} from "./chunk-7DQ4KIXX.js";
import "./chunk-GJCFV3G2.js";
import "./chunk-R4FN2FPU.js";
import "./chunk-J3DZJUY2.js";
import {
  Plugin,
  logWarning
} from "./chunk-H3OD3CNY.js";
import "./chunk-624QZG55.js";

// node_modules/@ckeditor/ckeditor5-easy-image/src/cloudservicesuploadadapter.js
var CloudServicesUploadAdapter = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "CloudServicesUploadAdapter";
  }
  /**
   * @inheritDoc
   */
  static get requires() {
    return ["CloudServices", FileRepository];
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    const cloudServices = editor.plugins.get("CloudServices");
    const token = cloudServices.token;
    const uploadUrl = cloudServices.uploadUrl;
    if (!token) {
      return;
    }
    const cloudServicesCore = editor.plugins.get("CloudServicesCore");
    this._uploadGateway = cloudServicesCore.createUploadGateway(token, uploadUrl);
    editor.plugins.get(FileRepository).createUploadAdapter = (loader) => {
      return new Adapter(this._uploadGateway, loader);
    };
  }
};
var Adapter = class {
  constructor(uploadGateway, loader) {
    this.uploadGateway = uploadGateway;
    this.loader = loader;
  }
  upload() {
    return this.loader.file.then((file) => {
      this.fileUploader = this.uploadGateway.upload(file);
      this.fileUploader.on("progress", (evt, data) => {
        this.loader.uploadTotal = data.total;
        this.loader.uploaded = data.uploaded;
      });
      return this.fileUploader.send();
    });
  }
  abort() {
    this.fileUploader.abort();
  }
};

// node_modules/@ckeditor/ckeditor5-easy-image/src/easyimage.js
var EasyImage = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "EasyImage";
  }
  /**
   * @inheritDoc
   */
  static get requires() {
    return [CloudServicesUploadAdapter, "ImageUpload"];
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    if (!editor.plugins.has("ImageBlockEditing") && !editor.plugins.has("ImageInlineEditing")) {
      logWarning("easy-image-image-feature-missing", editor);
    }
  }
};
export {
  EasyImage as default
};
/*! Bundled license information:

@ckeditor/ckeditor5-easy-image/src/cloudservicesuploadadapter.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-easy-image/src/easyimage.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
*/
//# sourceMappingURL=@ckeditor_ckeditor5-easy-image_src_easyimage.js.map
